/* CaptureAction.js */

"use strict";
const CaptureNameComponent = require("./veils/name/CaptureNameComponent");
const ScheduleVeilComponent = require("../../../../lib/actions/veils/schedule/ScheduleVeilComponent");

class CaptureAction {
    constructor(logger, gameEditor, DeviceEntity, userFeedback, userSession, jnibAdapter) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._modalUserFeedback = userFeedback;
        this._DeviceEntity = DeviceEntity;
        this._userSession = userSession;
        this._jnibAdapter = jnibAdapter;
        this._nibApiService = this._jnibAdapter.getNibApiService();

        this.run = this.run.bind(this);
    }

    run() {
        // Solution needs to be loaded first, else we ignore this action and let the user know
        return this._nibApiService
            .doesRefExist({
                orgId: this._userSession.activeOrganization.id,
                ref: "sys/jnib/features/deviceDetect/discoverDeviceJob.jnib",
            })
            .then((exists) => {
                if (exists) {
                    return this._modalUserFeedback
                        .displayCustom(new CaptureNameComponent(this._logger), {dontHide: true})
                        .then((result) => {
                            let name = result.name;
                            if (result.setSchedule) {
                                let workTarget = {
                                    method: "multi",
                                    ids: [this._gameEditor.getDevice().id],
                                    category: "entity",
                                    entityType: "Device",
                                };
                                return this._modalUserFeedback
                                    .displayCustom(
                                        new ScheduleVeilComponent(
                                            this._logger,
                                            true,
                                            "Capture - Schedule",
                                            {workType: "capture", firstTime: true}
                                        ),
                                        {dontHide: true},
                                        {
                                            dontHide: false,
                                        }
                                    )
                                    .then((scheduleDef) => {
                                        let displayName = name
                                            ? name.trim()
                                            : "Capture scheduled on " +
                                              new Date().toLocaleDateString() +
                                              " " +
                                              new Date().toLocaleTimeString();
                                        scheduleDef.workInput.description = displayName;
                                        return this._DeviceEntity.scheduleCaptureWork(
                                            this._userSession.activeOrganization.id,
                                            displayName,
                                            "",
                                            scheduleDef.schedule,
                                            workTarget,
                                            scheduleDef.workInput,
                                            {description: displayName}
                                        );
                                    })
                                    .then(() => {
                                        return this._modalUserFeedback.hideDisplayed();
                                    });
                            } else {
                                let jobInputs = {
                                    description: name ? name : "",
                                };
                                let workTarget = {
                                    method: "single",
                                    id: this._gameEditor.getDevice().id,
                                };
                                return this._DeviceEntity
                                    .runCaptureWork(
                                        this._userSession.activeOrganization.id,
                                        workTarget,
                                        jobInputs,
                                        {launchAndForget: true}
                                    )
                                    .then((result) => {
                                        if (result.errorMsg) {
                                            let err = new Error(result.errorMsg);
                                            err.errorCode = "CaptureError";
                                            err.errorMsg = result.errorMsg;
                                            throw err;
                                        }
                                        if (
                                            result.failed &&
                                            result.failed.length > 0 &&
                                            result.failed[0].errorCode === "StartJobError"
                                        ) {
                                            return Promise.reject(result.failed[0]);
                                        } else {
                                            return this._modalUserFeedback.hideDisplayed();
                                        }
                                    });
                            }
                        })
                        .catch((err) => {
                            if (err && err.userRejected) {
                                this._logger.warn(
                                    {error: err},
                                    "CaptureAction.run() - User Canceled"
                                );
                                return this._modalUserFeedback.hideDisplayed();
                            } else {
                                this._logger.warn({error: err}, "CaptureAction.run() - Error");
                                return this._modalUserFeedback.displayError(err).catch(() => {
                                    return Promise.resolve();
                                });
                            }
                        });
                } else {
                    this._modalUserFeedback.displayError({
                        errorMsg:
                            "Looks like you don’t have the Device Discovery package installed. Go to Solutions Management to install it.",
                        errorCode: "",
                    });
                    return false;
                }
            })
            .catch((err) => {
                this._logger.warn({error: err}, "CaptureAction.run().getNibApiService - Error");
                return this._modalUserFeedback.displayError(err);
            });
    }
}

module.exports = CaptureAction;

CaptureAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.entities.Device",
    "$teve.ui.userFeedback",
    "$teve.userSession",
    "$teve.jnibAdapter",
];

CaptureAction.$displayDetails = {
    type: "Action",
    name: "CaptureAction",
    icon: "configdrift.snapshot",
    title: "Capture Snapshot",
    shown: true,
    order: 2,
};
